import React from 'react';
import { useNavigate } from "react-router-dom";
import './TariffQuestions.css';
import { TarifPlansData } from "../../data/TarifPlansData";
import { handlePlanSelection } from "../../config/wayforpay";

const TariffQuestions = () => {
	const navigate = useNavigate();

	// Function for handling tariff plan selection
	const handlePlanClick = async (planId) => {
		// Find plan by ID
		const plan = TarifPlansData.find(p => p.id === planId);
		if (!plan) {
			console.error('Plan not found:', planId);
			return;
		}

		// Authorization check
		const token = localStorage.getItem('token');
		if (!token) {
			navigate('/SignIn');
			return;
		}

		// Payment processing through WayForPay
		await handlePlanSelection(plan);
	};
	return (
		<section className="tq-section">
			<div className="tq-inner">
				{/* Block 1 */}
				<div className="tq-item">
					<h3 className="tq-title">Why 386 UAH is the most profitable investment for you and your loved ones</h3>
					<p className="tq-text">
						30 original and bright greetings for just <span className="accent">386/30 = 12.87 UAH</span> each give you the opportunity to easily and naturally boost the festive
						mood for birthdays of close friends and major calendar holidays throughout the whole year. Such emotions and attention are priceless, especially in these
						times, and with Pryvitai it's even easier to create them and impossible to forget about important dates with the greeting calendar.
					</p>
					<button 
						className="tq-btn"
						onClick={() => handlePlanClick('yearly')}
					>
						Choose Yearly Plan
					</button>
				</div>

				{/* Block 2 */}
				<div className="tq-item">
					<h3 className="tq-title">When it's better to choose the "Greeter" plan right away</h3>
					<p className="tq-text">
						100 original and bright greetings for just <span className="accent">985/100 = 9.85 UAH</span> each give you a reason to stay connected with a wider circle of friends that you often don't
						have enough time for, and more opportunities to create true masterpieces. Also don't forget about yourself and gift original greeting cards to
						yourself for your own social networks.
					</p>
					<button 
						className="tq-btn"
						onClick={() => handlePlanClick('pryvitanator')}
					>
						Choose Greeter Plan
					</button>
				</div>

				{/* Block 3 */}
				<div className="tq-item">
					<h3 className="tq-title">How the "Generator" plan will enhance your networking or social media</h3>
					<p className="tq-text">
						If you're an active business person, then 300 greetings for just <span className="accent">1987/300 = 6.62 UAH</span> each will help you maintain connections with clients or
						colleagues. For creative personalities, the generator plan is a space for experiments and self-expression. You can create
						original or funny images for your own social networks and friends very easily and quickly.
					</p>
					<button 
						className="tq-btn"
						onClick={() => handlePlanClick('generator')}
					>
						Choose Generator Plan
					</button>
					</div>

			</div>
		</section>
	);
};

export default TariffQuestions;

